module.exports = __webpack_public_path__ + "img/feature-reports.acf9b0856b552cf796336b49105bfff1.png";